<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="联系人" prop="contactName">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.contactName"
          placeholder="请输入联系人"
        />
      </Form-item>
      <Form-item label="手机号" prop="contact">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.contact"
          placeholder="请输入手机号"
        />
      </Form-item>
      <Form-item label="留言内容" prop="content">
        <Input
          class="c-form__input"
          type="textarea"
          :rows="4"
          v-model.trim="cForm.model.content"
          placeholder="请输入留言内容"
        />
      </Form-item>
      <Form-item label="回复内容" prop="reply">
        <Input
          class="c-form__input"
          type="textarea"
          :rows="4"
          v-model.trim="cForm.model.reply"
          placeholder="请输入回复内容"
        />
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "@/mixins/form";

const module = "messages";

@Component({
  mixins: [FormMixin]
})
export default class extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          contactName: [
            {
              required: true,
              message: "联系人不能为空"
            }
          ],
          contact: [
            {
              pattern: /^1\d{2}\s?\d{4}\s?\d{4}$/,
              message: "手机号格式错误"
            }
          ],
          content: [
            {
              required: true,
              message: "留言内容不能为空"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {
      status: 1
    };
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;

        await this.$store.dispatch(`${module}/${id ? "put" : "post"}`, {
          id,
          body: model
        });

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list");
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
